import { IoBusinessOutline } from "react-icons/io5";
import SearchableSelectDropdown from "./SearchableSelectDropdown";

const PublisherFilterDropdown = ({
	publishers = [],
	value = "",
	onChange,
	fullWidth = false,
}) => (
	<SearchableSelectDropdown
		label="Publisher"
		icon={IoBusinessOutline}
		items={publishers}
		value={value}
		onChange={onChange}
		fullWidth={fullWidth}
		searchPlaceholder="Search publishers..."
		searchLabel="Search publishers"
		emptyMessage="No publishers yet"
		noMatchMessage="No publishers match your search"
	/>
);

export default PublisherFilterDropdown;
